import React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableCell,
  TextInput,
} from "@backslashbuild/pp-ui";

const c = {
  item: 300,
  collective: 300,
  paye: 300,
  total: 300,
};

function DscTable() {
  const [state, setState] = React.useState({
    grossEarnings: 0,
    dscUplift: 0,
    vatProvision: 0,
    vatLiability: 0,
    vatExemptGross: 0,
    vatableGross: 0,
    vat: 0,
    appLevy: 0,
    appLevyVat: 0,
  });

  const invoiceTotal =
    Number(state.grossEarnings) +
    Number(state.dscUplift) +
    Number(state.vatProvision) +
    Number(state.vatLiability) +
    Number(state.vatExemptGross) +
    Number(state.vatableGross) +
    Number(state.vat) +
    Number(state.appLevy) +
    Number(state.appLevyVat);
  function getStateUpdateHandler(key) {
    return (event) => setState({ ...state, [key]: Number(Number(event.target.value).toFixed(2)) });
  }

  const box = (key) => (
    <TextInput type="number" onChange={getStateUpdateHandler(key)} value={state[key]} />
  );

  return (
    <Table fullPageTable={true}>
      <TableHeader>
        <TableHeaderColumn width={c.item}>Item</TableHeaderColumn>
        <TableHeaderColumn width={c.total}>Total</TableHeaderColumn>
      </TableHeader>
      <TableBody fullPageTable={true}>
        <TableRow disableHover>
          <TableCell width={c.item}>Gross Earnings</TableCell>
          <TableCell width={c.total}>{box("grossEarnings")}</TableCell>
        </TableRow>

        <TableRow disableHover>
          <TableCell width={c.item}>DSC Uplift</TableCell>
          <TableCell width={c.total}>{box("dscUplift")}</TableCell>
        </TableRow>
        <TableRow disableHover>
          <TableCell width={c.item}>VAT Provision</TableCell>
          <TableCell width={c.total}>{box("vatProvision")}</TableCell>
        </TableRow>
        <TableRow disableHover>
          <TableCell width={c.item}>VAT Liability</TableCell>
          <TableCell width={c.total}>{box("vatLiability")}</TableCell>
        </TableRow>
        <TableRow disableHover>
          <TableCell width={c.item}>VAT Exempt Gross</TableCell>
          <TableCell width={c.total}>{box("vatExemptGross")}</TableCell>
        </TableRow>
        <TableRow disableHover>
          <TableCell width={c.item}>VATable Gross</TableCell>
          <TableCell width={c.total}>{box("vatableGross")}</TableCell>
        </TableRow>

        <TableRow disableHover>
          <TableCell width={c.item}>VAT</TableCell>
          <TableCell width={c.total}>{box("vat")}</TableCell>
        </TableRow>

        <TableRow disableHover>
          <TableCell width={c.item}>App Levy</TableCell>
          <TableCell width={c.total}>{box("appLevy")}</TableCell>
        </TableRow>

        <TableRow disableHover>
          <TableCell width={c.item}>App Levy VAT</TableCell>
          <TableCell width={c.total}>{box("appLevyVat")}</TableCell>
        </TableRow>

        <TableRow disableHover>
          <TableCell width={c.item}>Invoice Total</TableCell>
          <TableCell width={c.total}>
            <TextInput type="number" disabled value={invoiceTotal} />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default DscTable;
